import XAPPService from "app/Core/services/XAPPService";
import { GETCUSTOM_TAG_FUNCIONALIDADE, GET_TAG_FUNCIONALIDADE, TagFuncionalidadeListState } from "app/ERP/TagFuncionalidade/Store/Actions/TagFuncionalidadeActions";
import _ from "lodash";

export const GET_EMPRESAPESSOAS = "[EMPRESAPESSOA APP] GET PESSOAS";
export const GET_EMPRESAPESSOA = "[EMPRESAPESSOA APP] GET PESSOA";
export const GET_TEMPLATE = "[EMPRESAPESSOA APP] GET TEMPLATE";
export const GET_EMPRESAPESSOA_TIPOS = "[EMPRESAPESSOA APP] GET TIPOS";
export const EMPRESAPESSOA_GRUPOS = "[EMPRESAPESSOA APP] GET EMPRESAPESSOA GRUPOS";

export const OPEN_NEW_EMPRESAPESSOA_DIALOG = "[EMPRESAPESSOA APP] OPEN NEW PESSOA DIALOG";
export const CLOSE_EMPRESAPESSOA_DIALOG = "[EMPRESAPESSOA APP] CLOSE NEW PESSOA DIALOG";

export const EMPRESAPESSOA_VINCULAR = "[EMPRESAPESSOA APP] PESSOA VINCULAR";
export const EMPRESAPESSOA_REMOVE = "[EMPRESAPESSOA APP] PESSOA REMOVE";
export const ADD_EMPRESAPESSOA = "[EMPRESAPESSOA APP] ADD PESSOA";

export const EMPRESAPESSOA_WARNING = "[EMPRESAPESSOA APP] PESSOA WARNING";
export const EMPRESAPESSOA_INFO = "[EMPRESAPESSOA APP] PESSOA INFO";
export const EMPRESAPESSOA_ERROR = "[EMPRESAPESSOA APP] PESSOA ERROR";

const ListState = [
    "idpessoaformulario",
    "idpessoa",
    "idparent",
    "foto",
    "nome",
    "tags",
    "documentoprimario",
    "formulario",
    "fone",
    "foneprefix",
    "celular",
    "celularprefix",
    "whatsapp",
    "whatsappprefix",
    "facebook",
    "instagram",
    "website",
    "hangouts",
    "skype",
    "webex",
    "email",
    "statusregistro",
    "statusregistrodescricao",
    "usrins",
    "usrupt",
    "datainsdescricao",
    "datauptdescricao",
    "totalrows",
    "paginas",
];

const AddState = [
    "idparent",
    "formulario",
    "idpessoa",
    "tipo",
];

const UpdateState = [
    "formulario"
];

export function get(_AIDPessoaFormulario, _AParams, _ATarget = null) {

    return (dispatch, getState) => {

        const { data } = getState().Pessoa.TagFuncionalidadeReducer;
        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];
        var ATarget = !_.isNull(_ATarget) ? _ATarget : "spvwempresapessoa";

        AConditionsAND = [{ "Campo": "pessoaformulario.idpessoaformulario", "Operador": "=", "Valor": _AIDPessoaFormulario }];
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "Pessoa", AActions, ATarget, ListState, "SELECIONAR", AConditionsAND, AConditionsOR);

        if (_.isNull(data)) {
            AConditionsAND = [{ "Campo": "tagfuncionalidade.tipo", "Operador": "=", "Valor": "produto" }];
            AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "tagfuncionalidade", AActions, "spvwtagfuncionalidade", TagFuncionalidadeListState, "SELECIONAR", AConditionsAND, AConditionsOR);
        }

        XAPPService.XappSelAction(AActions, _AParams, "SEL")
            .then((response) => {
                Promise.all([
                    dispatch({
                        type: GET_EMPRESAPESSOA,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) && !_.isNull(JSON.parse(response.data)[0].data) ? JSON.parse(response.data)[0].data[0] : "",
                    })
                ]);
                if (_.isNull(data)) {
                    dispatch({
                        type: GET_TAG_FUNCIONALIDADE,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[1].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[1].data : "",
                    });
                }
            })
            .catch(error => {
                return dispatch({
                    type: EMPRESAPESSOA_ERROR,
                    payload: error
                });
            });
    };
}

export function list(_AAction, _AParams, _AFilter = null, _APagina = 1, _ATarget = null, _ACallback = null) {

    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];
        var ATarget = !_.isNull(_ATarget) ? _ATarget : "spvwempresapessoa";

        if (_AFilter !== null) {
            if (_AFilter.AND !== undefined && _AFilter.AND !== null) {
                AConditionsAND = AConditionsAND.concat(_AFilter.AND);
            }

            if (_AFilter.OR !== undefined && _AFilter.OR !== null) {
                AConditionsOR = AConditionsOR.concat(_AFilter.OR);
            }
        }

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "Pessoas", AActions, ATarget, ListState, _AAction, AConditionsAND, AConditionsOR, _APagina);

        AConditionsAND = [{ "Campo": "tagfuncionalidade.tipo", "Operador": "=", "Valor": _AParams.customTags }];
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "tagfuncionalidade", AActions, "spvwtagfuncionalidade", TagFuncionalidadeListState, "SELECIONAR", AConditionsAND, AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams, "SEL")
            .then((response) => {
                Promise.all([
                    dispatch({
                        type: GET_EMPRESAPESSOAS,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                        pagina: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].pagina : 1,
                    })
                    , dispatch({
                        type: GETCUSTOM_TAG_FUNCIONALIDADE,
                        Name: "pessoa",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[1].data : "",
                    })
                ]);
                if (!_.isNull(_ACallback)) {
                    _ACallback();
                }
            }
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAPESSOA_ERROR,
                    payload: error
                });
            });
    };
}

export function openNewDialog() {
    return {
        type: OPEN_NEW_EMPRESAPESSOA_DIALOG,
    };
}

export function closeDialog() {
    return {
        type: CLOSE_EMPRESAPESSOA_DIALOG,

    };
}

export function save(_AValue, _AParams, _ACallback = null) {
    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];
        var AAction = "INSERIR";

        if (_AValue.idpessoaformulario) {
            AAction = "ATUALIZAR";
            AConditionsAND = [{ "Campo": "idpessoaformulario", "Operador": "=", "Valor": _AValue.idpessoaformulario }];
            AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", AAction, _AValue, "idpessoaformulario", AConditionsAND, AConditionsOR, 1, UpdateState);

        }
        else {
            AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", AAction, _AValue, "idpessoaformulario", AConditionsAND, AConditionsOR, 1, AddState);
        }

        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: EMPRESAPESSOA_WARNING,
                            payload: response.warning
                        })
                    ]).then(() => {
                        if (!_.isNull(_ACallback)) {
                            _ACallback();
                        }
                    });
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: EMPRESAPESSOA_INFO,
                            payload: response.info,
                            id: response.ultimoidinserido
                        }),
                    ]).then(() => {
                        if (!_.isNull(_ACallback)) {
                            _ACallback();
                        }
                    });
                }
            }

            ).catch(error => {
                return dispatch({
                    type: EMPRESAPESSOA_ERROR,
                    payload: error
                });
            });
    };
}

export function getTemplate() {
    return (dispatch) => {

        XAPPService.XappGetTemplateAction("pessoa", "117")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_TEMPLATE,
                        payload: response,
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAPESSOA_ERROR,
                    payload: error
                });
            });
    };
}

export function getPessoaTipo() {
    return (dispatch, getState) => {
        XAPPService.XappGetTemplateAction("tipopessoa", getState().auth.user.data.settings.pathtipopessoa)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_EMPRESAPESSOA_TIPOS,
                        payload: response,
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAPESSOA_ERROR,
                    payload: error
                });
            });
    };
}

export function acaoRegistro(_AValue, _AParams, _AAction, _ACallback = null) {
    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "idpessoaformulario", "Operador": "=", "Valor": _AValue.idpessoaformulario }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", _AAction, "", "", AConditionsAND, AConditionsOR);

        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then(() =>
                Promise.all([
                    dispatch({
                        type: EMPRESAPESSOA_REMOVE
                    })
                ]).then(() => {
                    if (!_.isNull(_ACallback)) {
                        _ACallback();
                    }
                })
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAPESSOA_ERROR,
                    payload: error
                });
            });
    };
}

export function vincularUsuario(_AValue, _AParams, _AAction, _AForm) {
    return (dispatch) => {
        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];
        _AValue.tipo = 1;
        _AValue.formulario = { idpessoaformulario: _AForm.idpessoaformulario };

        var AResponse = 1;
        if (_AAction === "REMOVERFUNCIONARIO") {
            AResponse = 0;
        }

        AActions = XAPPService.XappCustomActionFactory(_AParams.empresa, AActions, "spdoactionregistro", _AAction, _AValue, "", AConditionsAND, AConditionsOR);
        XAPPService.XappRegisterAction(AActions, "CUSTOM")
            .then(() =>
                Promise.all([
                    dispatch({
                        type: EMPRESAPESSOA_VINCULAR,
                        payload: AResponse
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAPESSOA_ERROR,
                    payload: error
                });
            });
    };
}

export function clearAlterVinculo() {
    return {
        type: EMPRESAPESSOA_VINCULAR,
        payload: null
    };
}

export function clearReducer() {
    return {
        type: GET_EMPRESAPESSOAS,
        data: null,
        pagina: 1,
    };
}